<template>
  <div id="app">
    <transition name="show-from-left">
        <popover name="helpdata" :width="240">
            <Help :titleChart="titleChart"> 
            <div slot="content">
              <p> {{ $t("259") }}</p>
            </div>     
          </Help>
        </popover>
    </transition>

    <div class="title-charts title-bt-help title-margin-da">{{ $t("260") }} 
      <button class="bt-help" v-popover:helpdata.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin';

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'

export default {
  name: 'charts',  
  components: {
    Help
  },
  data () {
    return {
      titleChart: this.$t("260"),
      tableData: [],
      chartOptions: {
        //colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8'],
        chart: {
          type: 'heatmap',
          backgroundColor: 'rgba(0,0,0,0)',
          marginTop: 40,
          // marginBottom: 80,
          plotBorderWidth: 1,
          height: 520
        },

        title: {
            text: '',
        },

        xAxis: {
          // categories: ['mar-19', 'abri-19', 'mai-19', 'jun-19', 'jul-19', 'ago-19', 'set-19', 'out-19', 'nov-19', 'dez-19']
          categories: [],
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },

        yAxis: {
          // categories: ['JC', 'MEIO AMBIENTE', 'PACKAGING', 'PROCESSO', 'PROCESSO CERVEJA', 'UTILIDADES'],
          categories: [],
          title: null,
          reversed: true,
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
        },

        accessibility: {
            point: {
                descriptionFormatter: function (point) {
                    var ix = point.index + 1,
                        xName = this.getPointCategoryName(point, 'x'),
                        yName = this.getPointCategoryName(point, 'y'),
                        val = point.value;
                    return ix + '. ' + xName + ' sales ' + yName + ', ' + val + '.';
                }
            }
        },

        colorAxis: {
          stops: [
              [0, '#ffffff'],
              [0.80, '#ffffff'],
              [1, '#305496'],
          ],
          min: 0
        },

        legend: {
            align: 'right',
            layout: 'vertical',
            margin: 0,
            verticalAlign: 'middle',
            y: 25,
            symbolHeight: 280
        },

        tooltip: {
            formatter: function () {
              let value = this.point.value

              if (value || value == 0){
                return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>' + value + ' %' +'</b> in <br><b>' + this.point.series.xAxis.categories[this.point.options.x] + '</b>';
              }
              return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>No data!</b>'
            },
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
              color: '#F0F0F0'
            }
        },

        series: [{
            name: 'Data Availability',
            borderWidth: 1,
            // data: [[0, 0, 97], [0, 1, 98], [0, 2, 99], [0, 3, 99], [0, 4, 99], [1, 0, 100], [1, 1, 90], [1, 2, 96], [1, 3, 100], [1, 4, 90], [2, 0, 99], [2, 1, 100], [2, 2, 123], [2, 3, 64], [2, 4, 52], [3, 0, 72], [3, 1, 132], [3, 2, 114], [3, 3, 19], [3, 4, 16], [4, 0, 38], [4, 1, 5], [4, 2, 8], [4, 3, 117], [4, 4, 115], [5, 0, 88], [5, 1, 32], [5, 2, 12], [5, 3, 6], [5, 4, 120], [6, 0, 13], [6, 1, 44], [6, 2, 88], [6, 3, 98], [6, 4, 96], [7, 0, 31], [7, 1, 1], [7, 2, 82], [7, 3, 32], [7, 4, 30], [8, 0, 85], [8, 1, 97], [8, 2, 123], [8, 3, 64], [8, 4, 84], [9, 0, 47], [9, 1, 114], [9, 2, 31], [9, 3, 48], [9, 4, 91]],
            data: [],
            dataLabels: {
                enabled: true,
                color: '#000000',
                fontSize: '24px',
            },
        }],

        plotOptions: {
          series: {
            dataLabels:{
              enabled: true,
              formatter:function() {
                return '<span style="font-size:14px;" >' +  this.point.value + '</span>';
              }
            }
          },
          heatmap: {
            nullColor: '#000',
          }
        },

        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },

        exporting: { enabled: false },
        credits: {
          enabled: false
        },
      }
    }
  },
  mixins: [mixin],
  methods: {
    getPointCategoryName(point, dimension){
      var series = point.series,
      isY = dimension === 'y',
      axis = series[isY ? 'yAxis' : 'xAxis'];
      return axis.categories[point[isY ? 'y' : 'x']];
    },
    getData(){
      const API = process.env.ROOT_API;
      
      let param = {
        'corp': this.filtersOn.corp,
        'region': this.filtersOn.region,
        'planta': this.filtersOn.planta,
        'period': this.filtersOn.period,
        'year': this.filtersOn.year,
        'area_f': this.filtersOn.area_f,
        'sector_f': this.filtersOn.sector_f,
        'machine': this.filtersOn.machine,
        'subset': this.filtersOn.subset,
      }

      this.$refs.chart.chart.showLoading();

      let self = this;
      axios({method: 'GET', url: API + 'v1/mysemeq-ambev/get-data-availability', params: param, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
          .then(function({ data }){
              if (data){
                self.$refs.chart.chart.hideLoading();
                self.chartOptions.series[0].data = data[0];
                self.chartOptions.xAxis.categories = data[1];
                let yAxis = data[2];
                yAxis[0] = (self.filtersOn.planta_name == 'All' ? '' : self.filtersOn.planta_name) || self.filtersOn.region || 'ABInBev'; // Nome da planta/região na primeira posicao do Y
                
                if(data[2].length > 11){
                  self.chartOptions.chart.height = 1300
                }else{
                  self.chartOptions.chart.height = 520
                }
                
                self.chartOptions.yAxis.categories = yAxis;

                if (data[0].length == 0){
                  self.$refs.chart.chart.showLoading('No data');
                }
              }
          })
          .catch(function(error){
            self.$refs.chart.chart.showLoading('Error');

            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
          })
    }
  },  
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
      this.getData();
    },
  }
}
</script>
<style >
.highcharts-title tspan {
    fill: #fff;
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    color: #fff;
    font-weight: normal;
    font-size: 14px;
}
.highcharts-axis-labels tspan {
    fill: #fff;
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    color: #fff;
    font-weight: normal;
    font-size: 10px;
}
.highcharts-axis-labels text tspan {
  color: #fff!important;
}
.highcharts-axis-labels text{
  color: #fff!important;
}
.highcharts-text-outline {
  fill: none!important;
  stroke: none!important;
  color: #000!important;
}

div[data-popover="helpdata"] {
  left: 60% !important;
  top: 0% !important;
}

.title-margin-da{
  margin-bottom: -20px;
  position: absolute;
  top: 0px;
  right: 0%;
  z-index: 99999;
  width: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/HeatMap.vue